import useOperationTranslation from "../../../hooks/useOperationTranslation";
import FormInput from "../../common/FormInput";
import * as Mui from "@mui/material";
import { TransferReasonTypes } from "../Types";

interface Props {
  carSegment?: TransferReasonTypes.CarSegmentDetails[];
}

const CarSegment = (props: Props) => {
  const t = useOperationTranslation();

  return (
    <>
      {props.carSegment?.map((carSegmentInfo: any, index: number) => (
        <Mui.Box key={`carSegmentInfo-box`} mb={2}>
          <Mui.Card key={`carSegmentInfo-card-${index}`}>
            <Mui.CardContent key={`carSegmentInfo-card-content-${index}`}>
              <>
                <Mui.Grid
                  container
                  key={`carSegmentInfo-grid-content-${index}`}
                  columns={12}
                  alignItems="center"
                  spacing={2.5}
                  rowGap={4}
                >
                  <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                    <FormInput
                      name="carSegmentId"
                      label={t("transferReason.details.tab2.carSegment")}
                      value={
                        carSegmentInfo?.description !== undefined
                          ? carSegmentInfo?.description
                          : ""
                      }
                      type="text"
                      disabled
                      fullWidth
                    />
                  </Mui.Grid>
                  <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                    <FormInput
                      name="vehiclesNum"
                      label={t("transferReason.details.tab2.vehiclesNumber")}
                      value={
                        carSegmentInfo?.vehiclesNum !== undefined
                          ? carSegmentInfo?.vehiclesNum
                          : ""
                      }
                      type="number"
                      disabled
                      fullWidth
                    />
                  </Mui.Grid>
                </Mui.Grid>
              </>
            </Mui.CardContent>
          </Mui.Card>
        </Mui.Box>
      ))}
    </>
  );
};

export default CarSegment;
